module.exports = __webpack_public_path__ + "static/logo-wambi-purple-e7acf490c8661e2cede941fccfe0a2b4.svg";